/* eslint-disable react/prop-types */
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Alert } from 'components/alerts';
import MemberListResultsTable from 'components/member/member-list-results-table';
import LoadingIndicator from 'components/loading-indicator'; // ✅ import your new loader
import Box from 'components/box'; // ✅ to center loader nicely
import { Text } from 'components/text';

class MemberListResult extends Component {
  static mapStateToProps = state => ({
    isLoadingMemberList: state.members.isLoadingMemberList,
    memberListError: state.members.memberListError,
    memberList: state.members.memberList,
  });

  render() {
    const { isLoadingMemberList, memberListError, memberList } = this.props;

    if (isLoadingMemberList) {
      return (
        <Box
          flex
          alignItems="center"
          flexDirection="column"
        >
          <LoadingIndicator noun="members" title="Fetching Members, Please wait ....." />
        </Box>
      );
    }

    if (memberListError) {
      return <Alert type="error">{memberListError}</Alert>;
    }

    return <MemberListResultsTable data={memberList} />;
  }
}

export default connect(MemberListResult.mapStateToProps)(MemberListResult);
